<template>
  <div>
    <div class="it-header-wrapper">
      <div class="it-nav-wrapper">
        <div class="it-header-center-wrapper">
          <div class="container">
            <div class="row">
              <div class="col-9">
                <div class="it-header-center-content-wrapper">
                  <div class="it-brand-wrapper">
                    <router-link to="/">
                      <a href="#">
                        <div class="avatar size-xl">
                          <img :src="site.img_ponte_gressoney.src" alt="">
                        </div>
                        <div class="it-brand-text" v-on:click="apriBeniCulturali">
                          <h2 class="no_toc padding_left_15">Catalogo Beni Culturali</h2>
                          <h3 class="no_toc d-none d-md-block padding_left_15">Regione Autonoma Valle d'Aosta</h3>
                        </div>
                      </a>
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <a class="btn btn-primary btn-icon" href="#" @click="goLogin()" title="Login"
                  aria-label="Accedi all'area personale">
                  <span class="rounded-icon">
                    <svg class="icon icon-primary">
                      <use :xlink:href="site.baseurl+'/dist/svg/sprite.svg#it-user'"></use>
                    </svg>
                  </span>
                  <span class="d-none d-lg-block">&nbsp;Accesso all'area riservata</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="it-header-navbar-wrapper">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <nav class="navbar navbar-expand-lg has-megamenu">
                  <button class="custom-navbar-toggler" type="button" aria-controls="navHeader" aria-expanded="false"
                    aria-label="Toggle navigation" data-target="#navHeader" v-on:click="clickNavBar">
                    <i class="fas fa-bars fa-2x text-white"></i>
                  </button>
                  <div class="navbar-collapsable" id="navHeader">
                    <div class="overlay"></div>
                    <div class="close-div sr-only">
                      <button class="btn close-menu" type="button"><span class="it-close"></span>close</button>
                    </div>
                    <div class="menu-wrapper">
                      <ul class="navbar-nav">
                        <li v-if="$route.name=='HomePage'" class="nav-item active"><a
                            v-on:click="pushRouter('HomePage')" class="nav-link active" href="#">
                            <span>Home</span></a></li>
                        <li v-else class="nav-item"><a v-on:click="pushRouter('HomePage')" class="nav-link"
                            href="#"><span>Home</span></a></li>
                        <li v-if="$route.name=='ListDocuDigitali'" class="nav-item active"><a class="nav-link active"
                            v-on:click="pushRouter('ListDocuDigitali')" href="#"><span>Elenco Mappe Tematiche e Foto dei Villaggi</span></a>
                        </li>
                        <li v-else class="nav-item"><a class="nav-link" v-on:click="pushRouter('ListDocuDigitali')"
                            href="#"><span>Elenco Mappe Tematiche e Foto dei Villaggi</span></a>
                        </li>
                        <li v-if="$route.name=='ChiSiamo'" class="nav-item active"><a
                            v-on:click="pushRouter('ChiSiamo')" class="nav-link active" href="#"><span>Chi
                              Siamo</span></a></li>
                        <li v-else class="nav-item"><a v-on:click="pushRouter('ChiSiamo')" class="nav-link"
                            href="#"><span>Chi Siamo</span></a></li>
                      </ul>
                    </div>
                    <router-view :key="$route.fullPath"></router-view>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
  // @ is an alias to /src
  import Auth from '@/services/api/Auth_User.js'

  export default {
    name: 'Header',
    data() {
      return {
        site: {
          baseurl: process.env.VUE_APP_BOOTSTRAP_ITALIA_PATH,
          web2pyurl: process.env.VUE_APP_WEB2PYSITE,
          img_ponte_gressoney: {
            src: require('@/static/images/ponte_gressoney.png')
          }
        },
        error: ''
      }
    },
    methods: {
      apriBeniCulturali() {
        window.open(process.env.VUE_APP_URL_BENICULT);
      },
      goLogin() {
        Auth.getLogin()
          .then(data_login => {
            // console.log('data_login',data_login);
            this.url_login = data_login.url_login
          })
          .catch(function (error) {
            this.error = error;
          })
          .finally(() => {
            if (this.error != '') {
              console.error(this.error);
            } else {
              //console.log('url_login',this.url_login);
              window.location.replace(this.url_login)
            }
          });
      },
      clickNavBar() {
        document.getElementById("navHeader").className = "navbar-collapsable expanded collapse show";
        document.getElementById("navHeader").style.display = "block";
      },
      pushRouter(name) {
        this.$router.push({
          name: name
        }).catch(() => {});
      },

    }
  }

</script>
